<template>

    <el-dialog title="Cambiar turno" :visible.sync="visible" :before-close="handleClose">
        <el-form :model="resource">
            <el-form-item label="Empleado" label-width="100px">{{ resource.employee.company_id_number + ' - ' + resource.employee.name }}</el-form-item>
            <el-form-item label="Fecha" label-width="100px">{{ resource.date }}</el-form-item>
            <el-form-item label="Turno" label-width="100px">
                <el-select v-model="resource.shift_id" filterable placeholder="Seleccione" size="mini">
                    <el-option
                        v-for="item in shifts"
                        :key="item.id"
                        :label="item.description"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">Cancelar</el-button>
            <el-button type="primary" @click="handleSubmit">Confirmar</el-button>
        </span>
    </el-dialog>

</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { getOptionLabel } from '../../utils/lib';

    export default {
        name: 'workday-shift-assign',
        props:{
            visible: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                shifts: [],
                resource: {
                    employee: {
                        id: null,
                        company_id_number: null,
                        name: null
                    },
                    shift_id: null,
                    date: null,
                },
                edit: false,
            };
        },
        computed: {
            ...mapGetters(["functional_areas_with_shifts"]),
        },
        mounted() {
            this.fetchFunctionalAreasWithShifts();
        },
        methods: {
            ...mapActions(["fetchFunctionalAreasWithShifts"]),
            handleEdit: function(index, row) {
                this.resource.employee = this.data.employee;
                this.resource.date = this.data.date;
                this.resource.computed = this.data.computed;
                this.resource.shift_id = null;
                if (this.data.shift !== undefined) {
                    let shift = this.functional_areas_with_shifts[this.data.functional_area_id].shifts.find((shift) => { 
                        return shift.company_id_number === this.data.shift
                    });
                    if (shift !== undefined) {
                        this.resource.shift_id = shift.id;
                    }
                }
                this.shifts = _.sortBy(this.functional_areas_with_shifts[this.data.functional_area_id].shifts, 'description');
            },
            handleSubmit: function () {
                axios
                    .post("/api/employees/" + this.resource.employee.id + "/shifts", {
                        date_from: this.resource.date,
                        date_to: this.resource.date,
                        shift_id: this.resource.shift_id
                    })
                    .then(response => {
                        // console.log(response);
                        // this.$router.push(self.baseUrl);
                        // this.dialogShiftFormVisible = false;
                        // this.$refs.dataTable.fetchItems();
                        this.$emit('workdayShiftAssigned');
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            _.each(error.response.data, (value, key) => {
                                this.errors[key] = value.join(", ");
                            });
                        }
                    });
            },
            handleClose: function() {
                this.$emit('close');
            }
        }
    };
</script>
